<template>
  <button
    id="login-form-submit"
    type="submit"
    class="button button--white-hover-grad pulse"
  >
    <span
      v-if="!pending"
    >
      <slot />
    </span>
    <span
      v-if="pending"
    >
      <br>
      <Loader
        custom-class="size-sm button--loader"
      />
    </span>
  </button>
</template>

<script>
import Loader from '@/core/components/Loader';

export default {
  components: {
    Loader
  },
  props: {
    text:  {
      type: String,
      default() {
        return '';
      },
    },
    pending: {
      type: Boolean,
      default() {
        return false;
      },
    }
  }
};
</script>

<style>

</style>